<template>
  <div class="batch-order-detail-page">
    <a-spin :spinning="loading">
      <div class="page-body" v-if="detail">
        <div class="page-header">
          <h2 class="page-title">批量设置详情</h2>
          <p class="page-desc">设置编号：{{ detail.settingCode }}</p>
        </div>

        <div class="section-card">
          <div class="section-title">
            <span class="section-index">1</span>
            <span>基本信息</span>
          </div>
          <a-descriptions :column="2" bordered size="middle">
            <a-descriptions-item label="设置编号">{{ detail.settingCode }}</a-descriptions-item>
            <a-descriptions-item label="状态">{{ statusText }}</a-descriptions-item>
            <a-descriptions-item label="企业ID">{{ detail.enterpriseId }}</a-descriptions-item>
            <a-descriptions-item label="企业名称">{{ detail.enterpriseName || '--' }}</a-descriptions-item>
            <a-descriptions-item label="创建时间">{{ formatTime(detail.createTime) }}</a-descriptions-item>
            <a-descriptions-item label="更新时间">{{ formatTime(detail.updateTime) }}</a-descriptions-item>
          </a-descriptions>
        </div>

        <div class="section-card">
          <div class="section-title">
            <span class="section-index">2</span>
            <span>组织范围</span>
          </div>
          <a-table
            :columns="deptColumns"
            :data-source="detail.deptIdList || []"
            :pagination="false"
            row-key="deptId"
            bordered
            size="middle"
          />
        </div>

        <div class="section-card">
          <div class="section-title">
            <span class="section-index">3</span>
            <span>余额区间对应定制方案</span>
          </div>
          <a-table
            :columns="priceColumns"
            :data-source="detail.priceList || []"
            :pagination="false"
            row-key="id"
            bordered
            size="middle"
          >
            <template slot="priceRange" slot-scope="text, record">
              {{ record.startPrice }} — {{ record.endPrice }}
            </template>
            <template slot="pdf" slot-scope="text, record">
              <a v-if="record.pdfUrl" :href="record.pdfUrl" target="_blank">
                {{ record.pdfName || '下载PDF' }}
              </a>
              <span v-else>--</span>
            </template>
            <template slot="orderEndTime" slot-scope="text">
              {{ formatDate(text) }}
            </template>
            <template slot="travelDate" slot-scope="text">
              {{ formatDate(text) }}
            </template>
          </a-table>
        </div>

        <div class="page-footer">
          <a-button @click="goBack">返回</a-button>
        </div>
      </div>
    </a-spin>
  </div>
</template>

<script>
import moment from 'moment'

const STATUS_MAP = {
  0: '未开始',
  1: '进行中',
  2: '已完成'
}

export default {
  name: 'BatchorderDetail',
  data () {
    return {
      loading: false,
      detail: null,
      deptColumns: [
        {
          title: '部门ID',
          dataIndex: 'deptId',
          width: 120
        },
        {
          title: '部门名称',
          dataIndex: 'deptName'
        }
      ],
      priceColumns: [
        {
          title: '余额区间 (元)',
          dataIndex: 'priceRange',
          scopedSlots: { customRender: 'priceRange' },
          width: 160
        },
        {
          title: '对应定制方案',
          dataIndex: 'name'
        },
        {
          title: '方案PDF',
          dataIndex: 'pdf',
          scopedSlots: { customRender: 'pdf' }
        },
        {
          title: '订单支付截止日期',
          dataIndex: 'orderEndTime',
          scopedSlots: { customRender: 'orderEndTime' },
          width: 180
        },
        {
          title: '出游日期',
          dataIndex: 'travelDate',
          scopedSlots: { customRender: 'travelDate' },
          width: 140
        }
      ]
    }
  },
  computed: {
    statusText () {
      if (!this.detail) return '--'
      return STATUS_MAP[this.detail.status] || this.detail.status
    }
  },
  created () {
    this.fetchDetail()
  },
  methods: {
    formatTime (val) {
      if (!val) return '--'
      return moment(val).format('YYYY-MM-DD HH:mm:ss')
    },
    formatDate (val) {
      if (!val) return '--'
      return moment(val).format('YYYY-MM-DD')
    },
    fetchDetail () {
      const settingCode = this.$route.query.settingCode
      if (!settingCode) {
        this.$message.error('缺少设置编号')
        return
      }
      this.loading = true
      this.getHttpServices()
        .getNewServeService()
        .post(`/enterpriseTravelSetting/detail/${settingCode}`)
        .then(res => {
          this.detail = res || null
        })
        .catch(err => {
          this.$message.error((err && err.msg) || '获取详情失败')
        })
        .finally(() => {
          this.loading = false
        })
    },
    goBack () {
      this.$router.push({
        name: 'TravelMode',
        query: {
          tab: 'batchorder',
          serverUniqueId: this.$route.query.serverUniqueId
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
@primary: #faad14;
@text-main: rgba(0, 0, 0, 0.85);
@text-secondary: rgba(0, 0, 0, 0.45);
@border: #e8e8e8;

.batch-order-detail-page {
  min-height: 100%;
  background: #f5f5f5;
}

.page-body {
  margin: 16px;
  padding: 24px;
  background: #fff;
  border-radius: 4px;
}

.page-header {
  margin-bottom: 24px;
}

.page-title {
  margin: 0 0 8px;
  font-size: 20px;
  font-weight: 600;
  color: @text-main;
}

.page-desc {
  margin: 0;
  font-size: 13px;
  color: @text-secondary;
}

.section-card {
  margin-bottom: 20px;
  padding: 20px;
  border: 1px solid @border;
  border-radius: 4px;
}

.section-title {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  font-size: 16px;
  font-weight: 600;
  color: @text-main;
}

.section-index {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  margin-right: 8px;
  border-radius: 50%;
  background: @primary;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  line-height: 1;
}

.page-footer {
  display: flex;
  justify-content: flex-end;
}
</style>
